import type { ParagraphProps } from './Paragraph.types';

export const paragraphDefaults: ParagraphProps = {
  size: 'none',
  context: 'none',
  fontWeight: 'normal',
};
